import Vue from "vue"
import apiClient from "@/utils/cb-client"
import {
  hostedPageState,
  hostedPageActions,
  hostedPageMutations,
  hostedPageGetters,
  SET_LOADED, SET_PARTIALLY_LOADED} from "@/store/common/hosted-page"
import invoices from "@/store/portal/invoice"


const MARK_FOR_PAYMENT = "MARK_FOR_PAYMENT";
const SET_TOS_AGREED = "SET_TOS_AGREED"

const state = {
  ...hostedPageState
}

const actions = {
  ...hostedPageActions,
  fetch_data({commit, state, dispatch, rootState}, token) {
    Promise.all([
      dispatch('_fetch_data', token),
      dispatch('load_paynow_config')
    ]).then(() => {
      commit(SET_PARTIALLY_LOADED, true);
      dispatch('init_returning_user', {skipShippingAddressList: true})
      .then(() => {
        var promises = [];
        promises.push(dispatch('load_unpaid_invoices'));
        Promise.all(promises).then(() => {
          commit(SET_LOADED, true);
        });
      });
    });
  },

  load_unpaid_invoices({commit, state, dispatch, rootState, getters}, options) {
    var initial_count = getters.valid_invoices.length;
    return dispatch('load_paynow_invoices', options).then(() => {
      if(!getters.invoices_eol && initial_count == getters.valid_invoices.length) {
        return dispatch('load_unpaid_invoices', options);
      }
    });
  },

  reset_unpaid_invoices({commit, state, dispatch}) {
    dispatch('reset_invoice_list');
    commit(SET_LOADED, false);
    dispatch('load_unpaid_invoices').then(() => commit(SET_LOADED, true));
  },

  mark_selected_for_pm({commit, state}, invoice) {
    commit(MARK_FOR_PAYMENT, invoice);
  }
}

const mutations = {
  ...hostedPageMutations,
  [MARK_FOR_PAYMENT] (state, invoice) {
    Vue.set(invoice, 'selected_for_pm', !invoice.selected_for_pm);
  }
}

const getters = {
  ...hostedPageGetters,
  currency_code: (state, getters) => getters.preferred_currency_code,
  valid_invoices: (state, getters) => state.invoices.list.filter(i => i.currency_code == getters.currency_code && i.amount_to_collect > 0),
  amountToBePaid: (state, getters) => getters.selected_invoices.reduce((sum, invoice) => {
    sum += invoice.amount_to_collect;
    return sum;
  }, 0),
  totalDue: (state, getters) => getters.valid_invoices.reduce((sum, invoice) => {
    sum += invoice.amount_to_collect;
    return sum;
  }, 0),
  selected_invoices: (state, getters) => getters.valid_invoices.filter(i => i.selected_for_pm)
}


export default {
  state,
  actions,
  mutations,
  getters,
  modules: {
    invoices
  }
}